export enum KnmErpFormFieldsNamesTemplatesEnum {
  APPROVE_ORDER_NUMBER = 'approveOrderNumber',
  CHECKLIST = 'checklists[i]',
  CHECKLIST_NAME = 'checklists[i].name',
  CHECKLIST_OBJECT = 'checklists[i].object',
  CHECKLIST_ERVK = 'checklists[i].ervkCheckList',
  COLLABORATING_KNO_NAME = 'collaboratingKnoName',
  COLLABORATING_ORGANIZATION = 'collaboratingOrganizations[i]',
  COLLABORATING_ORGANIZATION_ORGANIZATION = 'collaboratingOrganizations[i].organization',
  DECISION_PLACE = 'decisionPlace',
  DOCUMENT = 'documents[i]',
  DOCUMENT_TYPE = 'documents[i].type',
  DURATION_DAYS = 'durationDays',
  DURATION_HOURS = 'durationHours',
  FORM_LINK_TYPE = 'linkType',
  EVENTS = 'events',
  EVENT = 'events[i]',
  EVENT_NAME = 'events[i].name',
  EVENT_START_DATE = 'events[i].startDate',
  EVENT_STOP_DATE = 'events[i].stopDate',
  HEAD_ORDER_NUMBER = 'headOrderNumber',
  INN = 'inn',
  INSPECTION_TARGET = 'inspectionTarget',
  INSPECTOR = 'inspectors[i]',
  INSPECTOR_FULLNAME = 'inspectors[i].fullName',
  INSPECTOR_POSITION = 'inspectors[i].position',
  INSPECTOR_TYPE = 'inspectors[i].type',
  INSPECTOR_ERVK = 'inspectorsErvk[i]',
  INSPECTOR_ERVK_FULLNAME = 'inspectorsErvk[i].fullName',
  INSPECTOR_ERVK_POSITION = 'inspectorsErvk[i].position',
  FEDERAL_LAW = 'federalLaw',
  KIND = 'kind',
  KIND_ERVK = 'kindErvk',
  KNO_ORGANIZATION = 'knoOrganization',
  KNO_ORGANIZATION_ERVK = 'knoOrganizationErvk',
  LEGAL_BASES = 'legalBases',
  AUDITED_PERSON_AUTHORITY = 'auditedPersonAuthority',
  AUDITED_PERSON_AUTHORITY_OBJECT = 'auditedPersonAuthority[i].authority',
  MONTH = 'month',
  OBJECTS = 'objects',
  OBJECT = 'objects[i]',
  OBJECT_OBJECT_NAME = 'objects[i].name',
  OBJECT_ERVK_ADDRESS = 'objectsErvk[i].address',
  OBJECT_ERVK_ADDRESS_TYPE = 'objectsErvk[i].addressType',
  OBJECT_ERVK_OBJECT_TYPE = 'objectsErvk[i].objectType',
  OBJECT_ADDRESS = 'objects[i].address',
  OBJECT_ADDRESS_TYPE = 'objects[i].addressType',
  OBJECT_OBJECT_TYPE = 'objects[i].objectType',
  OBJECT_SUPERVISION = 'objects[i].supervisions[i]',
  OBJECT_RESULT = 'objectsResults[i]',
  OBJECT_RESULT_OBJECT = 'objectsResults[i].object',
  OBJECT_RESULT_ACT_CREATE_DATE = 'objectsResults[i].actCreateDate',
  OBJECT_RESULT_ACT_ADDRESS = 'objectsResults[i].actAddress',
  OBJECT_RESULT_ACT_ADDRESS_TYPE = 'objectsResults[i].actAddressType',
  OBJECT_RESULT_START_DATE = 'objectsResults[i].startDate',
  OBJECT_RESULT_DURATION_DAYS = 'objectsResults[i].durationDays',
  OBJECT_RESULT_DURATION_HOURS = 'objectsResults[i].durationHours',
  OBJECT_RESULT_INSPECTOR_FULL_NAME = 'objectsResults[i].inspectors[i].fullName',
  OBJECT_RESULT_INSPECTOR_POSITION = 'objectsResults[i].inspectors[i].position',
  OBJECT_RESULT_INSPECTOR_TYPE = 'objectsResults[i].inspectors[i].type',
  OBJECT_RESULT_DELEGATE_FULL_NAME = 'objectsResults[i].delegates[i].fullName',
  OBJECT_RESULT_DELEGATE_POSITION = 'objectsResults[i].delegates[i].position',
  OBJECT_RESULT_DELEGATE_TYPE = 'objectsResults[i].delegates[i].type',
  OBJECT_RESULT_ADDITIONAL_INFO_INFORMATION = 'objectsResults[i].additionalInfo[i].information',
  OBJECT_RESULT_ADDITIONAL_INFO_TYPE = 'objectsResults[i].additionalInfo[i].type',
  OGRN = 'ogrn',
  ORDER_DATE = 'orderDate',
  ORDER_NUMBER = 'orderNumber',
  ORGANIZATION_NAME = 'organizationName',
  PROSECUTOR_ORGANIZATION = 'prosecutorOrganization',
  REASONS = 'reasons',
  REASONS_ERVK = 'reasonsErvk',
  REASON_TYPE_ERVK = 'reasonsErvk[i].type',
  REASON_ORDER_ERVK = 'reasonsErvk[i].order',
  REASON = 'reasons[i]',
  REASON_TYPE = 'reasons[i].type',
  REASON_TEXT = 'reasons[i].text',
  REASON_DATE = 'reasons[i].date',
  REASON_ASSIGNMENT_NUMBER = 'reasons[i].assignmentNumber',
  REASON_ASSIGNMENT_DATE = 'reasons[i].assignmentDate',
  REASON_REQUIREMENT_DETAILS = 'reasons[i].requirementDetails',
  REASON_LAST_CONDUCTED_DATE = 'reasonsErvk[i].lastConductedKnmDate',
  REASON_RISK_INDICATORS = 'reasonsErvk[i].riskIndicators',
  REASONS_ERP_RISK_INDICATOR = 'reasonsErvk[i].riskIndicators[i].riskIndicator',
  REJECT_REASON = 'rejectReasons',
  REJECT_REASON_TEXT = 'rejectReasons[i].text',
  REJECT_REASON_TYPE = 'rejectReasons[i].type',
  REQUIREMENTS = 'requirements',
  RESULT_CANCELLATION_INFO = 'resultsCancellationInfo[i]',
  RESULT_CANCELLATION_INFO_INFORMATION = 'resultsCancellationInfo[i].information',
  RESULT_CANCELLATION_INFO_RESULT = 'resultsCancellationInfo[i].result',
  SIGNER_FULL_NAME = 'signerFullName',
  SIGNER_POSITION = 'signerPosition',
  START_DATE = 'startDate',
  STOP_DATE = 'stopDate',
  SUBJECT_TYPE = 'subjectType',
  SUBJECT_TYPE_ERVK = 'subjectTypeErvk',
  SUPERVISION_TYPE = 'supervisionType',
  SUPERVISION_TYPE_ERVK = 'supervisionTypeErvk',
  TYPE = 'type',
  TYPE_ERVK = 'typeErvk',
  VIOLATION = 'violations[i]',
  VIOLATION_RESULT = 'violations[i].result',
  VIOLATION_TYPE = 'violations[i].type',
  VIOLATION_NOTE = 'violations[i].note',
  VIOLATION_LAWSUIT = 'violationsLawsuits[i]',
  VIOLATION_LAWSUIT_VIOLATION = 'violationsLawsuits[i].violation',
  VIOLATION_LAWSUIT_ITEM_LAWSUIT_TYPE = 'violationsLawsuits[i].lawsuits[i].lawsuitType',
  VIOLATION_LAWSUIT_ITEM_TEXT = 'violationsLawsuits[i].lawsuits[i].text',
  INTERACTION_CATEGORY = 'interactionCategory',
}
